import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConfigServiceProvider} from "../config-service/config-service";
import {StorageServiceProvider} from "../storage-service/storage-service";

/*
  Generated class for the NotWorkingDaysConfigServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class NonWorkingDaysConfigServiceProvider {

  constructor(public http: HttpClient, private configService: ConfigServiceProvider, private storageService: StorageServiceProvider) {
  }

  load() {
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getUrl('nonWorkingDays'))
        .toPromise()
        .then((response: any) => {
          let nonWorkingDays = response.params.nonWorkingDays;
          this.storageService.setObject('nonWorkingDays', nonWorkingDays)
            .then(res => resolve(res))
            .catch(err => reject(err));
        })
        .catch((err) => reject(err));
    })
  }

  getNonWorkingDays() {
    return this.storageService.getObject('nonWorkingDays');
  }

}



// WEBPACK FOOTER //
// ./src/modules/core/services/non-working-days-config-service/non-working-days-config-service.ts